module.exports = __webpack_public_path__ + "img/brazo-extensor-2.d8e2890d.png";